/* unplugin-vue-components disabled */import script from "./Rechargerecord.vue?vue&type=script&setup=true&name=Rechargerecord&lang=js"
export * from "./Rechargerecord.vue?vue&type=script&setup=true&name=Rechargerecord&lang=js"

import "./Rechargerecord.vue?vue&type=style&index=0&id=06d4148d&lang=scss&scope=true"

const __exports__ = script;

export default __exports__